import { render } from "./PlatformsTab.vue?vue&type=template&id=7fba1d29&scoped=true"
import script from "./PlatformsTab.vue?vue&type=script&lang=js"
export * from "./PlatformsTab.vue?vue&type=script&lang=js"

import "./PlatformsTab.vue?vue&type=style&index=0&id=7fba1d29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fba1d29"]])

export default __exports__